import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import ClientStepper from '@/routes/Brand/Requests/Request/components/shared/ClientStepper';
import { PendingShipmentPreparation } from '@/routes/Brand/Requests/Request/components/shared/PendingShipmentPreparation';
import { PickupPointInfo } from '@/routes/Brand/Requests/Request/components/shared/PickupPointInfo/PickupPointInfo';

import { StepMessage } from '../../shared/StepMessage';

const Transit = ({ request }: { request: RequestWithRelations }) => {
  const activeArticlesInTransit = request.articles.filter(
    (article) => article.step?.step === 'transit' && !article.cancelledAt
  );
  const isPendingTransit = activeArticlesInTransit.some(
    (article) => article.atClient || (!!request.storeId && article.atEntityId === request.storeId)
  );

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        <ClientStepper request={request} />
        {isPendingTransit &&
          (request.store ? (
            <PendingTransitFromStoreHeader
              request={request}
              articlesInTransit={activeArticlesInTransit}
            />
          ) : (
            <PendingShipmentPreparation
              request={request}
              articlesInTransit={activeArticlesInTransit}
            />
          ))}
        {!isPendingTransit && <InTransitHeader articlesInTransit={activeArticlesInTransit} />}
        <PickupPointInfo request={request} />
        <ClientArticlesList request={request} showPrice showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};

const PendingTransitFromStoreHeader = ({
  request,
  articlesInTransit,
}: {
  request: RequestWithRelations;
  articlesInTransit: ArticleWithRelations[];
}) => {
  return (
    <StepMessage
      iconDone
      message={
        <Trans id="client.request.transit.pending.title">
          Your service is confirmed. Your{' '}
          <Plural value={articlesInTransit.length} one="item" other="items" /> will be sent to the
          repair workshop by the {request.store?.name} store.
        </Trans>
      }
    />
  );
};

const InTransitHeader = ({ articlesInTransit }: { articlesInTransit: ArticleWithRelations[] }) => {
  return (
    <StepMessage
      message={
        <Trans id="client.request.transit.in-transit.store-shipment">
          Your{' '}
          <Plural
            value={articlesInTransit.length}
            one="item is on its"
            other="items are on their"
          />{' '}
          way to the workshop to be taken care of.
        </Trans>
      }
    />
  );
};

export default Transit;
